<template>
  <div class="directions-map-wrap">
    <div id="directions-map" class="map-canvas" aria-hidden="true"></div>
    <MapGps :map="map" directionsGps="true"></MapGps>
  </div>
</template>

<script>
import L from 'leaflet';
import Map from '@/assets/Map.js'
import MarkerGenerator from '@/assets/MarkerGenerator.js'
import MapFunctions from '@/assets/MapFunctions.js'
import MapOverlays from '@/assets/routePlanner/MapOverlays.js'
import { EventBus } from '@/main.js'
import MapGps from '@/components/map/MapGps.vue'

export default {
  data() {
    return {
      map: false,
      mapContent: {},
      routeLayers: L.layerGroup(),
      destinationMarkers: {
  	    start: '',
  	    end: '',
  	    via: '',
  	  },
  	  destinationMarkersStyles: {
        start: L.divIcon({
        	iconSize: [35, 35],
        	iconAnchor: [17.5, 17.5],
        	className: 'svg-div-marker',
        	html: '<div class="marker" data-direction="start"><div class="round-icon" style="background-color: rgb(151, 191, 13);"></div></div><div class="marker-icon-bg"><div class="marker-icon"><span class="marker-text">Start</span></div></div>'
        }),
        end: L.divIcon({
        	iconSize: [35, 35],
        	iconAnchor: [17.5, 17.5],
        	className: 'svg-div-marker',
        	html: '<div class="marker" data-direction="end"><div class="round-icon" style="background-color: rgb(000,143,73);"></div></div><div class="marker-icon-bg"><div class="marker-icon"><span class="marker-text">Slut</span></div></div>'
        }),
        via: L.divIcon({
        	iconSize: [35, 35],
        	iconAnchor: [17.5, 17.5],
        	className: 'svg-div-marker',
        	html: '<div class="marker" data-direction="via"><div class="round-icon" style="background-color: rgb(230,23,112);"></div></div><div class="marker-icon-bg"><div class="marker-icon"><span class="marker-text">Via</span></div></div>'
        }),
  	  },
      trafficInfoActivatedBefore: false,
      parkingActivatedBefore: false,
      stepByStepDot: false,
    }
  },
  props: {
    routeData: {
      default: () => {},
    },
    startOptions: {},
    endOptions: {},
    viaOptions: {},
    showRoadwork: {
      required: true,
    },
    showParking: {
      required: true,
    },
    typeOfParking: {
      required: true,
    },
  },
  components: {
    MapGps,
  },
  watch: {
    routeData() {
      this.routeCalculated();
    },
    startOptions() {
      this.setDestinationPoint(this.startOptions);
    },
    endOptions() {
      this.setDestinationPoint(this.endOptions);
    },
    viaOptions() {
      this.setDestinationPoint(this.viaOptions);
    },
    showRoadwork() {
      this.toggleRoadwork();
    },
    showParking() {
      this.toggleParking();
    },
    typeOfParking() {
      this.changeParkingType();
    },
  },
  created() {
    EventBus.$on('goToStep', (lat, lng) => {
  		this.goToRouteDetailStep(lat, lng);
    });
    EventBus.$on('closeRouteDetails', () => {
  		this.map.map.removeLayer(this.stepByStepDot);
  		this.stepByStepDot = false;
    });
  },
  mounted() {
    var settings = this.$DeviceCheck.isMobile ? {addZoomControl: false, addAttribution: true} : {addZoomControl: true, controlPosition: 'bottomright', addAttribution: true};
    this.map = new Map('directions-map', settings);
    this.MapOverlays = new MapOverlays(this.map.map, this.showRoadwork, this.showParking);
    this.map.map.invalidateSize();

    this.map.map.on('contextmenu', e => {
			this.selectDestinationOnMap(e);
		});
  },
  methods: {
    toggleRoadwork() {
      this.$root.$emit('toggleLoadingScreen', true);
      this.MapOverlays.showTrafficInfoOnMap = this.showRoadwork;
      this.MapOverlays.checkLayers();
      this.$root.$emit('toggleLoadingScreen', false);
    },
    toggleParking() {
      this.$root.$emit('toggleLoadingScreen', true);
      if(this.showParking == true) {
        this.MapOverlays.showParkingOnMap = true;
        this.MapOverlays.checkLayers();
        if(this.map.map.getZoom() < 15) {
          this.map.map.setZoom(15);
        }
      }
      else {
        this.MapOverlays.showParkingOnMap = false;
        this.MapOverlays.checkLayers();
      }

      this.$root.$emit('toggleLoadingScreen', false);
    },
    changeParkingType() {
      if(this.typeOfParking == 'bike') {
  			this.MapOverlays.showBikeParkingOnMap = true;
  			this.MapOverlays.showCarParkingOnMap = false;
  		}
  		else {
  			if(this.typeOfParking == 'car') {
  				this.MapOverlays.showBikeParkingOnMap = false;
  				this.MapOverlays.showCarParkingOnMap = true;
  			}
  			else {
  				this.MapOverlays.showBikeParkingOnMap = false;
  				this.MapOverlays.showCarParkingOnMap = false;
  			}
  		}
      this.MapOverlays.checkLayers();
    },

    routeCalculated() {
      console.log(this.routeData);
      this.routeLayers.clearLayers();
  		for(var i in this.routeData) {
  			if(this.routeData[i] != false) {
          if(this.routeData[i].selected == true) {
            //Alert if redirection on route
            if(this.routeData[i].alternateRoute == true) {
              console.log(this.routeData[i].message);
              let settings = {message: this.routeData[i].message};
              EventBus.$emit('openMessageBox', settings);
            }

            this.MapOverlays.sortTrafficInfo(this.routeData[i]);

            if(this.routeData[i].type == 'car' || this.routeData[i].type == 'pedestrian') {
              document.getElementById('route-type-'+this.routeData[i].type+'-text').innerHTML = this.routeData[i].timeAndDistance;
            }
            else {
              document.getElementById('route-type-bike-text').innerHTML = this.routeData[i].timeAndDistance;
            }

            var bounds = [];
      	    for(var k in this.routeData[i].route.routeCoords.geometry.coordinates) {
      	      if(this.routeData[i].route.routeCoords.geometry.coordinates[k][1] != false && this.routeData[i].route.routeCoords.geometry.coordinates[k][0] != undefined) {
      	        bounds.push([this.routeData[i].route.routeCoords.geometry.coordinates[k][1], this.routeData[i].route.routeCoords.geometry.coordinates[k][0]]);
      	      }
      	    }
      	    this.map.map.fitBounds(bounds);
          }

          var opacity = this.routeData[i].selected ? '0.7' : '0.3';
  				var layer = L.geoJson(this.routeData[i].route.routeCoords, {
  					style: () => {
  						var options = {'color': this.routeData[i].routeColor, 'weight': '5', 'opacity': opacity};
  						return options;
  					}
  				});

  				this.routeLayers.addLayer(layer);
  			}
  		}

  		this.routeLayers.addTo(this.map.map);
  		/*if(this.inTripMode) {
  			this.adjustEndPointOnRoute();
  		}*/
    },
    setDestinationPoint(options) {
      //Remove any existing marker
      if(this.map.map.hasLayer(this.destinationMarkers[options.direction]) || options.remove) {
        this.destinationMarkers[options.direction].off('dragend');
        this.map.map.removeLayer(this.destinationMarkers[options.direction]);
      }
      if(options.remove != true) {
        //Set new marker
        this.destinationMarkers[options.direction] = L.marker([options.coords.lat, options.coords.lng],
          {icon: this.destinationMarkersStyles[options.direction], draggable: true}
        ).addTo(this.map.map);

        //Add events for dragging the marker
        this.destinationMarkers[options.direction].on('dragend', e => {
          var direction = e.sourceTarget._element.firstChild.dataset.direction;
          var options = {direction: direction, type: 'coords', coords: {lat: e.target._latlng.lat, lng: e.target._latlng.lng}};
          this.$emit('selectedOnMap', options);
        });

        this.map.map.setView([options.coords.lat, options.coords.lng]);
      }
    },
    selectDestinationOnMap(e) {
  		if(!this.mapSelectPopup) {
  			this.mapSelectPopup = L.popup({'className': 'map-popup map-destination-popup', 'maxWidth': '220', 'maxHeight': '120'});
  		}

  		var html = '<span class="map-select-option" data-direction="start"><span class="material-icons light-green-text">place</span>Vælg startpunkt</span>\
  													<span class="map-select-option" data-direction="end"><span class="material-icons green-text">place</span>Vælg slutpunkt</span>\
  													'+((!this.inTripMode) ? '<span class="map-select-option" data-direction="via"><span class="material-icons pink-text">place</span>Tilføj viapunkt</span>' : '');

  		this.mapSelectPopup.setLatLng(e.latlng).setContent(html).openOn(this.map.map);

      var coords = {
  			lat: parseFloat(e.latlng.lat),
  			lng: parseFloat(e.latlng.lng)
  		};

      var elems = document.getElementsByClassName('map-select-option');

      for(var i = 0; i < elems.length; i++) {
        //elems[i].removeEventListener('click');
        elems[i].addEventListener('click', e => {
          var direction = e.currentTarget.getAttribute('data-direction');
          var options = {direction: direction, type: 'coords', coords: {lat: coords.lat, lng: coords.lng}};

          this.$emit('selectedOnMap', options);
          this.mapSelectPopup._close();
        });
      }
  	},
    goToRouteDetailStep(lat, lng) {
      var center = MapFunctions.calcOffset([lat,lng], this.map.map);
  		if(!this.stepByStepDot) {
  			var icon = L.divIcon({className: 'gps-circle', html: '<div class="gps-circle-dot step-by-step-dot" style="background-color: rgb(0,112,141)"></div>'});
  			this.stepByStepDot = L.marker([lat,lng], {icon: icon}).addTo(this.map.map);
  		}
  		else {
  			this.stepByStepDot.setLatLng([lat,lng]);
  		}
  		this.map.map.setView(center);
    }
  }
}
</script>

<style lang="scss" scoped>
  .directions-map-wrap {
    height: 100%;
    width: 100%;
  }

  #directions-map {
    height: 100%;
    width: 100%;
  }

  #directions-map ::v-deep .map-destination-popup {
    min-width: 150px;
    text-align: center;
  }

  #directions-map ::v-deep .map-select-option {
  	display: block;
    height: 30px;
    padding-left: 30px;
    line-height: 30px;
    vertical-align: middle;
    margin-bottom: 10px;
    cursor: pointer;
  }

  #directions-map ::v-deep .map-select-option:last-child {
    margin-bottom: 0px;
  }

  #directions-map ::v-deep .map-select-option .material-icons {
  	position: absolute;
  	left: 0px;
  	font-size: 25px !important;
  }

  .step-by-step-dot {
  	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
  	border: 1px solid white;
  	margin-left: -5px;
    margin-top: -5px;
  }
</style>
